<template>
  <v-form ref="convertDeliveryAddressForm" @submit.prevent>
    <v-btn
      type="submit"
      color="blue darken-2"
      class="white--text"
      @click.stop="submitForm"
      :loading="loading"
    >
      Convert Submit
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ConvertDeliveryAddress",

  props: {},

  data: () => ({
    loading: false,

    required(fieldName) {
      return (v) => (v && v.length > 0) || `${fieldName} Required`;
    },
  }),

  methods: {
    ...mapActions(["convertUserDeliveryAddress"]),

    async submitForm() {
      console.log("Submitting....");
      this.loading = true;
      await this.convertUserDeliveryAddress();
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>